import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

export const SobreMi = () => {
  const { t, c } = useLanguage();

  const renderText = (text) => {
    return text
      .replace('{colombia}', c.colombia)
      .replace('{brasil}', c.brasil)
      .replace('{mexico}', c.mexico)
      .replace('{alemania}', c.alemania)
      .replace('{francia}', c.francia);
  };

  return (
    <section id="sobre-mi" className="py-20 lg:py-32 bg-[#0B0B0B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative order-2 lg:order-1"
          >
            <div className="relative overflow-hidden aspect-[4/5]">
              <img
                src="/imagenes/sitio/ramiro-artista.jpg"
                alt="Ramiro Tattoo Artist"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                data-testid="sobre-mi-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-transparent to-transparent opacity-60" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8 order-1 lg:order-2"
          >
            <h2
              className="text-4xl sm:text-5xl lg:text-6xl font-light text-[#F5F5F5] tracking-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
              data-testid="sobre-mi-title"
            >
              {t.sobreMi.title}
            </h2>

            <div className="space-y-6 text-base sm:text-lg text-[#9CA3AF] leading-relaxed">
              {t.sobreMi.text.map((paragraph, index) => {
                if (index === 1) {
                  const parts = paragraph.split(/(\{[^}]+\})/g);
                  return (
                    <p key={index}>
                      {parts.map((part, i) => {
                        if (part.match(/\{([^}]+)\}/)) {
                          const country = part.replace(/[{}]/g, '');
                          return (
                            <motion.span
                              key={i}
                              whileHover={{ color: '#F5F5F5' }}
                              className="text-[#9CA3AF] transition-colors cursor-default"
                            >
                              {c[country]}
                            </motion.span>
                          );
                        }
                        return part;
                      })}
                    </p>
                  );
                }
                return <p key={index}>{paragraph}</p>;
              })}
            </div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="flex items-center justify-center lg:justify-start gap-2 text-xs tracking-[0.2em] text-[#9CA3AF] pt-4"
            >
              <span>{c.colombia.toUpperCase()}</span>
              <span className="text-[#E5E5E5]">·</span>
              <span>{c.brasil.toUpperCase()}</span>
              <span className="text-[#E5E5E5]">·</span>
              <span>{c.mexico.toUpperCase()}</span>
              <span className="text-[#E5E5E5]">·</span>
              <span>{c.alemania.toUpperCase()}</span>
              <span className="text-[#E5E5E5]">·</span>
              <span>{c.francia.toUpperCase()}</span>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="border-l-4 border-[#E5E5E5] pl-6 py-4"
            >
              <p
                className="text-xl sm:text-2xl lg:text-3xl font-light text-[#F5F5F5] leading-relaxed tracking-tight whitespace-pre-line"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {t.sobreMi.quote}
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
